export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-19-ae1c73d488ef7a1cd0ebf7dec11e35f7.jpg";